export const CATEGORY_DELETE_RESET = 'CATEGORY_DELETE_RESET'
export const CATEGORY_DELETE_SET_ERROR = 'CATEGORY_DELETE_SET_ERROR'
export const CATEGORY_DELETE_SET_DELETED = 'CATEGORY_DELETE_SET_DELETED'
export const CATEGORY_DELETE_TOGGLE_LOADING = 'CATEGORY_DELETE_TOGGLE_LOADING'
